export default __webpack_public_path__ + "3bf6442f6e9083833de15a78bdd391bb.png";